import React from 'react'

export default function DropdownArrow() {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 4.5L7 9.5L2 4.5" stroke="#C5C5C5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
